// extracted by mini-css-extract-plugin
export var allBtn = "main-module--all-btn--f3fd6";
export var btnBlock = "main-module--btn-block--ccf1a";
export var mainBtn = "main-module--main-btn--acd97";
export var mainTitle = "main-module--main-title--99067";